import axios from 'axios';



//开发商基本信息查询   '/ej-isp-api/zk/ywcx/kfsinfo'
function Api_devKfsjbxxcx(dwzh) {
    return new Promise((resolve,reject) =>{
        axios.post('/ej-isp-api/zk/ywcx/kfsinfo', {}, {
            data: {
                para: {
                    "jydm": "developerInfo",
                    "extParam": {
                        "developerno": dwzh
                    }
                }
            }
        }).then(res =>{
            //获取成功
            resolve(res.data);
        }).catch(error =>{
            //获取失败
            console.log(error);
            reject(error);
        })
    })
}



//开发商基本信息变更   '/ej-isp-api/zk/ywcx/kfsinfo'
function Api_devKfsjbxxbg(form) {
    return new Promise((resolve,reject) =>{
        axios.post('/ej-isp-api/zk/ywbl/kfschange', {}, {
            data: {
                para: {
                    "jydm": "developerChange",
                    "extParam": {
                        ...form
                    }
                }
            }
        }).then(res =>{
            //获取成功
            resolve(res.data);
        }).catch(error =>{
            //获取失败
            console.log(error);
            reject(error);
        })
    })
}




export {
    Api_devKfsjbxxcx,
    Api_devKfsjbxxbg
}



// WEBPACK FOOTER //
// ./src/static/js/api/dev/devinfo.js